function typeEqual (obj, type) {
  return Object.prototype.toString.call(obj) === '[object ' + type + ']'
}

export function isFunction (object) {
  return typeEqual(object, 'Function')
}

export function isString (object) {
  return typeEqual(object, 'String')
}

export function isObject (object) {
  return typeEqual(object, 'Object')
}

export function isJSON (str) {
  if (isString(str)) {
    try {
      JSON.parse(str)
      return true
    } catch (e) {
      return false
    }
  }
  return false
}

/**
 * Convert an Array-like object to a real Array.
 */
export function toArray (list, start) {
  start = start || 0
  let i = list.length - start
  const ret = new Array(i)
  while (i--) {
    ret[i] = list[i + start]
  }
  return ret
}

export function noop () {
}
